import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import ProfileContext from "./ProfileContext";

const Div = styled.div`
  border-top: 1px solid var(--username-border-color, #161618);
  transition: height 0.25s ease-out;
  overflow: hidden;
  cursor: pointer;

  .header {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding: 15px 10px 0 15px;
    height: 45px;

    .data {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .header-left-side {
      display: flex;
      align-items: center;
      gap: 25px;

      label {
        margin-bottom: 0;
        cursor: pointer;
      }
    }
  }

  .username {
    color: var(--text-primary, #161618);
    font-size: 13px;
    font-style: normal;
    font-family: "AllianceNo2-SemiBold";
  }

  .hostname {
    color: var(--text-primary, #161618);
    opacity: 0.5;
  }

  .options {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
  }
  .option {
    min-height: 38px;
    color: var(--Text-Secondary);
    font-family: "AllianceNo2-SemiBold";
    padding-left: 50px;
    margin: 0px 15px;
    border-radius: 5px;
    cursor: pointer;
    padding-top: 11px;

    &:hover {
      background-color: var(--background-menu-hover);
      color: var(--text-primary);
    }
  }
`;

export function Username() {
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(false);
  const profile = useContext(ProfileContext);

  useEffect(() => {
    const darkEnabledStored = localStorage.getItem("darkEnabled");
    setDark(darkEnabledStored === "true" || darkEnabledStored === null);
  }, []);

  function toggleDarkMode() {
    localStorage.setItem("darkEnabled", (!dark).toString());
    location.reload();
  }

  function onLogout() {
    $("#modalLogout").modal("show");
  }

  return (
    <Div
      style={{
        height: open ? 140 : 60,
      }}
    >
      <div
        className="header"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        <div className="header-left-side">
          <i className="material-icons">person</i>
          <div className="data">
            <label className="username"> {profile.user}</label>
            <label className="hostname"> {profile.remoteHostname} </label>
          </div>
        </div>
        <span className={`expand-icon ${open ? "expanded" : ""}`}></span>
      </div>
      {open && (
        <div className="options">
          <label className="option" onClick={() => toggleDarkMode()}>
            {dark ? "Change to light mode" : "Change to dark mode"}
          </label>
          <label className="option" onClick={() => onLogout()}>
            Log out
          </label>
        </div>
      )}
    </Div>
  );
}
